// extracted by mini-css-extract-plugin
export default {"ques":"FAQ_ques__n2JKE","title":"FAQ_title__f2Ehw","FAQ":"FAQ_FAQ__4yo41","icon":"FAQ_icon__7B9vZ","ans":"FAQ_ans__1QDNa","show":"FAQ_show__4YA9v"};